import { useContext, useEffect, useState } from 'react';
import { SmartContext } from '../../../../../../library/Core/SmartContext';
import EditDemographicssModal from './EditDemographicssModal';
import EditDemographicsPageConfig from './FormConfiguration/EditDemographicsPageConfig.json';
import ProfileMarkerService from './ProfileMakerService';
import { Tooltip } from 'bootstrap';
import { allowPerformAction, displayActionNotAllowedAlert, isEmpty, setError } from '../../../../../../library/Core/SmartFunctions';
import { toast } from 'react-toastify';

type DemographicsProps = {
    age: { label: string,toolTip:string };
    genderCode: { label: string,toolTip:string,isComment:string };
    isSpouseSameInstitute: { label: string; isComment: string,toolTip:string };
    isSiblingSameInstitute: { label: string; isComment: string,toolTip:string };
    StudiedAbroad: { label: string,isComment: string,toolTip:string };
    CurrentlyAbroad: { label: string,isComment: string,toolTip:string };
    LivedAbroadandBack: { label: string; isComment: string,toolTip:string };
    DidnotTakeEducationloan: { label: string; isComment: string,toolTip:string };
    iswealthyNeighborhood:{ label: string; isComment: string,toolTip:string };
};

const DemographicsProps: DemographicsProps = {
    age: { label: 'Age', toolTip:"Age range of the alumnus"},
    genderCode: { label: 'Gender',isComment: 'genderCodeComment', toolTip:"Gender of the alumnus" },
    isSpouseSameInstitute: { label: 'Spouse also from same Institute', isComment: 'spouseComment', toolTip:"The spouse (husband/wife) of the alumnus also studied in the same institute making both of them alumni of your institute" },
    isSiblingSameInstitute: { label: 'Sibling also from same Institute', isComment: 'siblingComment', toolTip:"The sibling (brother/sister) of the alumnus also studied in the same institute making both of them alumni of your institute" },
    StudiedAbroad: { label: 'Study Abroad',isComment:'StudiedAbroadComment', toolTip:"Alumnus has studied in any institute outside the country" },
    CurrentlyAbroad: { label: 'Currently Abroad',isComment:'CurrentlyAbroadComment', toolTip:"Alumnus is currently living outside the country" },
    LivedAbroadandBack: { label: 'Lived Abroad and Back', isComment: 'LivedAbroadandBackComment', toolTip:"Alumnus is currently in the country, but at some point either studied or lived outside the country " },
    DidnotTakeEducationloan: { label: 'Took Education Loan', isComment: 'EducationLoanComment', toolTip:"Alumnus did not take any education loan to fund their studies when they were a student at your institute" },
    iswealthyNeighborhood: { label: 'Wealthy Neighborhood', isComment: 'wealthyNeighborhoodAddress', toolTip:"Alumnus is currently living in a wealthy neighborhood of their city" },

};

const keys = Object.keys(DemographicsProps) as (keyof DemographicsProps)[];

const 

Demographics = () => {
    const { state, dispatch } = useContext(SmartContext);
    const { saveMarker, saveSuggestionResponse, fetchUserProfileMarkers, fetchUserFromSameInstitute,handleOpenLogsModal,fetchUserSyncDetails } = ProfileMarkerService();
    const handleOpenModal = async (key: string) => {
        if (!allowPerformAction()) {
            displayActionNotAllowedAlert();
            return;
        }
        dispatch({ type: 'RESET_VALIDATION_ERRORS' });

        dispatch({
            type: 'REFRESH_DATA',
            payload: { data: { ...state.data, visibleControl: key } },
        });
        dispatch({ type: 'TOGGLE_MODAL_VISIBILITY', payload: { modalName: 'showDemoGraphicsModal' } });
    };
    //const userListFromSameInstitute = fetchUserFromSameInstitute(state.internal.model.id);
    const model = state.internal.model;
    const [isConfigAvailable, setisConfigAvailable] = useState(false);
    const markers = state.data.marker || [];
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        const tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new Tooltip(tooltipTriggerEl);
        });
    }, [state.data.demographics]);

    useEffect(() => {
        // Clean up demographics data based on existing rules
        const demographicsData = { ...state.data.demographics };
        Object.keys(DemographicsProps).forEach((key) => {
            const demographicsKey = key as keyof typeof DemographicsProps;
            const prop = DemographicsProps[demographicsKey];
            if (prop && typeof prop === 'object' && 'isComment' in prop) {
                const isCommentField = prop.isComment;
                if (demographicsData[demographicsKey] === false) {
                    // if (isCommentField) {
                    //     demographicsData[isCommentField as keyof typeof demographicsData] = '';
                    // }

                    if (demographicsKey === 'isSpouseSameInstitute') {
                        demographicsData['spauseId'] = '';
                    }

                    if (demographicsKey === 'isSiblingSameInstitute') {
                        demographicsData['siblingId'] = '';
                    }
                }
            }
        });

        if (demographicsData.iswealthyNeighborhood === false) {
            demographicsData.city = '';
            demographicsData.country = '';
            demographicsData.wealthyNeighborhoodAddress = '';
            demographicsData.locality = '';
            demographicsData.pinCode = '';
        }

        // If there's a change in demographics, update state
        if (JSON.stringify(state.data.demographics) !== JSON.stringify(demographicsData)) {
            dispatch({
                type: 'CONTROL_VALUE_CHANGE',
                payload: { dataKey: 'demographics', value: demographicsData },
            });
        }

        // Validate sync data after demographics data change
        const syncData = state?.data?.syncData?.[0] || {};
        let isFormInvalid = false;

        Object.keys(DemographicsProps).forEach((key) => {
            const demographicsKey = key as keyof typeof DemographicsProps;
            const prop = DemographicsProps[demographicsKey];
            if (prop && typeof prop === 'object' && 'isComment' in prop) {
              if (prop.isComment && state?.data?.visibleControl == key) {
                const commentField = prop.isComment as keyof typeof demographicsData;
                if (key === 'genderCode' && demographicsData[key] != syncData[key] 
                    && isEmpty(demographicsData[commentField])) 
                    {
                    isFormInvalid = true;
                    setError(
                        `demographics.${String(commentField)}`,
                        [`Please enter a comment for "${prop.label}" because the value has changed.`],
                        dispatch
                    );
                }
                else if((key === 'StudiedAbroad'|| key === 'CurrentlyAbroad' || key==='LivedAbroadandBack') && Boolean(demographicsData[key]) !== Boolean(syncData[key]) &&
                    isEmpty(demographicsData[commentField]) 
                ) {                   
                    isFormInvalid = true;
                    setError(
                        `demographics.${String(commentField)}`,
                        [`Please enter a comment for "${prop.label}" because the value has changed.`],
                        dispatch
                    );
                }
                else {
                    isFormInvalid = false;
                    setError(`demographics.${String(commentField)}`, [], dispatch);
                }
            }
          }
        });

        // Dispatch SHOW_ERRORS if form is invalid
        if (isFormInvalid) {
            dispatch({ type: 'SHOW_ERRORS' });
            return;
        }

    }, [state.data.demographics, state.data.syncData, dispatch]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const userListFromSameInstitute = await fetchUserFromSameInstitute(state.internal.model.id,'Demographics');
                let userListFromSameInstituteForSibling = await fetchUserFromSameInstitute(state.internal.model.id,'Sibling');
                const domainMap = new Map([...state.domain]);
                console.log(userListFromSameInstitute);
                domainMap.set('USER_FROM_SAME_INSTITUTE', userListFromSameInstitute);
                console.log(userListFromSameInstituteForSibling,'userListFromSameInstituteForSibling')
                domainMap.set('USER_FROM_SAME_INSTITUTE_FOR_SIBLING', userListFromSameInstituteForSibling);

                const userSynacdata = await fetchUserSyncDetails(state?.internal?.model?.id);
                console.log("userSynacdata",userSynacdata)

                dispatch({
                    type: 'CONTROL_VALUE_CHANGE',
                    payload: {
                        dataKey: 'syncData',
                        value: userSynacdata, 
                    },
                });

                const config = await Promise.resolve(EditDemographicsPageConfig);
                const defaultCountry = state?.data?.profile?.residingCountryCode; 
                const defaultCity = state?.data?.profile?.residingCityCode; 
                const defaultgenderCode = state?.data?.profile?.genderCode; 
                const defaultCurrentlyAbroad = userSynacdata?.[0]?.CurrentlyAbroad ? true : false;
                const defaultStudiedAbroad = userSynacdata?.[0]?.StudiedAbroad ? true : false;
                const defaultLivedAbroadandBack=userSynacdata?.[0]?.LivedAbroadandBack ? true : false;
                 
                const instituteId = state?.data?.selectedInstitute?.instituteId 
                 || state?.internal?.model?.instituteId

                dispatch({
                    type: 'DATA_INIT',
                    payload: {
                        formConfig: config,
                        data: {
                            ...state.data,
                            demographics: {
                              ...state.data.marker?.demographics,
                              country: state.data.marker?.demographics?.country || defaultCountry,
                              city: state.data.marker?.demographics?.city || defaultCity,
                              genderCode: state.data.marker?.demographics?.genderCode || defaultgenderCode,
                              CurrentlyAbroad: state.data.marker?.demographics?.CurrentlyAbroad !== undefined ? state.data.marker?.demographics?.CurrentlyAbroad : (state.data?.marker?.demographics?.CurrentlyAbroad ?? defaultCurrentlyAbroad),
                              StudiedAbroad: state.data.marker?.demographics?.StudiedAbroad !== undefined ? state.data.marker?.demographics?.StudiedAbroad : (state.data?.marker?.demographics?.StudiedAbroad ?? defaultStudiedAbroad),
                              LivedAbroadandBack: state.data.marker?.demographics?.LivedAbroadandBack !== undefined ? state.data.marker?.demographics?.LivedAbroadandBack : (state.data?.marker?.demographics?.LivedAbroadandBack ?? defaultLivedAbroadandBack),
                              instituteId: instituteId,  // 👈 add this

                            },
                            marker: {
                                ...state.data.marker,
                                demographics: {
                                    ...state.data.marker?.demographics,
                                    country: state.data.marker?.demographics?.country || defaultCountry,
                                    city: state.data.marker?.demographics?.city || defaultCity,
                                    genderCode: state.data.marker?.demographics?.genderCode || defaultgenderCode,
                                    CurrentlyAbroad: state.data.marker?.demographics?.CurrentlyAbroad !== undefined ? state.data.marker?.demographics?.CurrentlyAbroad : (state.data?.marker?.demographics?.CurrentlyAbroad ?? defaultCurrentlyAbroad),
                                    StudiedAbroad: state.data.marker?.demographics?.StudiedAbroad !== undefined ? state.data.marker?.demographics?.StudiedAbroad : (state.data?.marker?.demographics?.StudiedAbroad ?? defaultStudiedAbroad),
                                    LivedAbroadandBack: state.data.marker?.demographics?.LivedAbroadandBack !== undefined ? state.data.marker?.demographics?.LivedAbroadandBack : (state.data?.marker?.demographics?.LivedAbroadandBack ?? defaultLivedAbroadandBack),
                                },
                            },
                            visibleControl: {},
                        },
                        domain: domainMap,
                        internal: state.internal,
                        routeInfo: state.routeInfo,
                    },
                });
                setisConfigAvailable(true);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []);

    const [isOpen, setIsOpen] = useState<Record<string, boolean>>({});

    const isMarkerEnabled = (key: string): boolean => {
        const value = markers?.demographics?.[key];
        if (value === true) return true;
        if (typeof value === 'string') {
          if (!isEmpty(value)) {
            return true;
          }
        }
        return false;
      };

    const handleAccept = async (key: string, value: string, justification?: string) => {
        if (!allowPerformAction()) return;

        const marker = markers?.demographics?.[key];

        if (!marker) {
            console.warn("No marker found for key:", key);
            return;
        }

        const payload = {
            markerType: 'demographics',
            ...state?.data?.demographics
        };

        //remove the keys having 'Analisis' suffix
        Object.keys(payload).forEach((k) => {
            if (k.endsWith('Analysis')) {
                delete payload[k];
            }
        });

        payload[key] = value == 'yes' ? 1 : 0;
        payload[key + 'Comment'] = justification || marker?.remark || '';

        console.log("payload", payload);

        await saveMarker(payload, state.internal.model.id);
        await saveSuggestionResponse(key, state.internal.model.id, "Accepted");
        await fetchUserProfileMarkers(state.internal.model.id);

        toast.success("Suggestion Accepted");
    };

    const handleReject = async (key: string) => {
        if ( !allowPerformAction() ) return;
        const response = await saveSuggestionResponse(key, state.internal.model.id, 'Rejected');
        await fetchUserProfileMarkers(state?.internal?.model?.id);
        toast.success("Suggestion Rejected");
    };

    return (
        <div className="tab-pane fade active show" id="v-pills-demographics" role="tabpanel" aria-labelledby="v-pills-demographics-tab">
            <div className="max-470 mx-auto">
                <div className="row g-3">
                    {/* Replace this block with dynamic data */}
                    {keys.map((key) => {
                    const markerExists = markers?.demographics ? key in markers.demographics : false;

                    const markerEnabled = isMarkerEnabled(key);
                
                    const commentField = (DemographicsProps[key] as { label: string; isComment?: string }).isComment;
                    const comment = commentField
                        ? (markers?.demographics?.[commentField] ?? state.data.demographics?.[commentField] ?? '')
                        : '';
                
                    const value = markerExists ? markers.demographics[key] : null;
                
                    const spauseId = state.data.demographics?.spauseId;

                    const siblingId = state.data.demographics?.siblingId;

                    const analysis = state?.data?.marker?.demographics?.[`${key}Analysis`];
                    const isPendingAnalysis = analysis && !analysis.status;
                    const shouldShowSuggestion = isPendingAnalysis;
                    // const markerValueYes = analysis?.marker_value === "yes";
                    // const shouldShowSuggestion = isPendingAnalysis && (markerValueYes != markerExists);

                        return (
                            <div className="col-12" key={key}>
                                <div className="row g-3 align-items-center">
                                    <div className="col position-relative">
                                        {/** ---------- TOGGLE ARROW BUTTON ---------- */}
                                        {shouldShowSuggestion && (
                                            <button
                                                className="icon-down-arrow border-0 position-absolute bg-transparent btn-profile-toggle z-1 "
                                                type="button"
                                                data-bs-target={`#${key}Card`}
                                                aria-expanded={isOpen?.[key]}
                                                onClick={() => setIsOpen((prev:any) => ({ ...prev, [key]: !prev[key] }))}
                                            ></button>
                                        )}
                                    
                                    <div className={`listed-border ${markerEnabled ? '' : 'disabled'}`}>                                            <i className="tick"></i>
                                     
                                               <p
                                                onClick={() => !loading && handleOpenModal(key)} // Prevent click when loading
                                                style={{ cursor: loading ? 'not-allowed' : 'pointer' }} // Disable pointer cursor when loading
                                                >
                                                {DemographicsProps[key].label}{' '}
                                                {((key === 'isSpouseSameInstitute' && spauseId) || (key === 'isSiblingSameInstitute' && siblingId)) ? (
                                                    <a 
                                                        className="text-white" 
                                                        href={`/alumni/${(key === 'isSpouseSameInstitute') ? spauseId : siblingId}/profile`} 
                                                        target="_blank"
                                                        onClick={(event) => event.stopPropagation()} // Prevent the click event from bubbling up
                                                    >
                                                        View Profile
                                                    </a>
                                                ) : (
                                                    value ? ` - ${value == 1 ? `Yes` : value}` : ''
                                                )}
                                            </p>                              
                                            {(typeof comment === "string" && comment?.trim()?.length > 0) && (
                                                <span className="note-wrap" data-bs-toggle="tooltip" data-bs-html="true" title={comment}>
                                                    <i className="icon-note"></i>
                                                </span>
                                            )}

                                            
                                        </div>

                                        {/** ---------- COLLAPSIBLE ANALYSIS BODY ---------- */}
                                        {shouldShowSuggestion && (
                                            <div className={`listed-body ${analysis.confidence == 'high' ? 'orange' : 'yellow'} p-3 collapse ${(isOpen?.[key] == true) ? 'show' : ''}`} id={`${key}Card`}>
                                                <p>
                                                    Value - {analysis.marker_value[0]?.toUpperCase() + analysis.marker_value.slice(1)}
                                                </p>
                                                <p>{analysis.justification}</p>

                                                <div className="d-flex align-items-center">
                                                    <button
                                                        className="btn-green height-30 me-2"
                                                        onClick={() =>
                                                            handleAccept(
                                                                key,
                                                                analysis.marker_value,
                                                                analysis.justification
                                                            )
                                                        }
                                                    >
                                                        <span>Accept</span>
                                                    </button>

                                                    <button
                                                        className="btn btn-danger rounded-pill height-30 lh-base d-flex align-items-center"
                                                        onClick={() => handleReject(key)}
                                                    >
                                                        <span>Reject</span>
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    
                                    </div>

                                    
                                    <div className="col-auto">
                                        <i
                                            className="icon-info"
                                            data-bs-toggle="tooltip"
                                            title=""
                                            data-bs-original-title={DemographicsProps[key].toolTip}
                                            aria-label={DemographicsProps[key].toolTip}></i>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                    <div className="col-12 pt-3">
                        <button className="btn btn-dark-blue w-auto height-40 px-4 d-flex align-items-center mx-auto" onClick={() => handleOpenLogsModal()}>
                        <span className="text-white">View Update Logs</span>
                        </button>
                    </div>
                    {/* Repeat similar blocks for other items */}
                </div>
            </div>
            {isConfigAvailable && <EditDemographicssModal userdata={{ model }} DemographicsProps={DemographicsProps} />}
        </div>
    );
};
export default Demographics;
